import React, { useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import UpdatingSpinner from "../ui/UpdatingSpinner";
import {
  addJobService,
  setShowJobServiceModal,
  woocommerceCreateProduct,
} from "../plugins/plugin.redux";
import * as serialize from "form-serialize";

const slugify = (str) =>
  String(str || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 24);

const generateServiceSku = (name) => {
  const slug = slugify(name) || "svc";
  const suffix = Date.now().toString(36).slice(-5);
  return `SVC-${slug}-${suffix}`.toUpperCase();
};

const labelStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};
const modalStyle = {
  borderBottom: "transparent",
};
const bodyStyle = {
  borderBottom: "transparent",
  padding: "0rem 1rem 1rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const formStyle = {
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "column",
};

const doubleButtonStyle = {
  width: "30px",
  height: "100%",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const inputStyle = {
  width: "100%",
  height: "30px",
};
const colStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
  margin: "0.2em 0",
};

const rowStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  flexDirection: "column",
};

const rowContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const ModalRedux = (props) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const submittingRef = useRef(false);

  const {
    showJobServiceModal,
    setShowJobServiceModal,
    woocommerceCreateProduct,
    productCreating,
    productCreateError,
    addJobService,
    adding,
    pluginSubscriptions,
  } = props;

  const handleClose = () => {
    submittingRef.current = false;
    setShowJobServiceModal({ showJobServiceModal: false });
  };

  const handleAdd = () => {
    const form = formRef.current;
    const values = serialize(form, { hash: true });
    if (!values?.name || !values?.price) return;

    if (pluginSubscriptions?.includes("SPECTRE_POS")) {
      const jobService = {
        name: values.name,
        price: values.price,
        sku: generateServiceSku(values.name),
      };
      submittingRef.current = true;
      woocommerceCreateProduct({ jobService });
    } else {
      addJobService({ jobService: { ...values } });
      handleClose();
    }
  };

  useEffect(() => {
    if (!submittingRef.current) return;
    if (productCreating) return;
    if (productCreateError) {
      submittingRef.current = false;
      return;
    }
    handleClose();
  }, [productCreating, productCreateError]);

  return (
    <>
      <Modal
        size="sm"
        show={showJobServiceModal}
        onHide={handleClose}
        centered
        className={`select-modal jobService`}
      >
        <Modal.Header closeButton style={modalStyle}>
          <span style={labelStyle}>
            <span style={{ marginRight: 5 }}>
              {t(`jobBoard.addJobService`)}
            </span>
          </span>
        </Modal.Header>
        {adding || productCreating ? (
          <Modal.Body style={bodyStyle}>
            <UpdatingSpinner />
          </Modal.Body>
        ) : (
          <Modal.Body style={bodyStyle}>
            <Form ref={formRef}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
                style={formStyle}
              >
                <div className="row" style={rowContainerStyle}>
                  <div className="col-10">
                    <div className="row" style={rowStyle}>
                      <div className="col-12" style={colStyle}>
                        {t(`jobBoard.serviceName`)}:
                      </div>
                      <div className="col-12" style={{ padding: 0 }}>
                        <Form.Control
                          type="text"
                          placeholder=""
                          autoFocus
                          style={inputStyle}
                          name="name"
                        />
                      </div>
                    </div>
                    <div className="row" style={rowStyle}>
                      <div className="col-12" style={colStyle}>
                        {t(`jobBoard.price`)}:
                      </div>
                      <div className="col-12" style={{ padding: 0 }}>
                        <Form.Control
                          step="1"
                          type="number"
                          placeholder=""
                          autoFocus
                          style={inputStyle}
                          name="price"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-2"
                    style={{
                      height: 107,
                      padding: 0,
                      paddingLeft: 3,
                      paddingTop: 23,
                    }}
                  >
                    <Button onClick={handleAdd} style={doubleButtonStyle}>
                      <FontAwesomeIcon icon={["fas", "arrow-down"]} />
                    </Button>
                  </div>
                </div>
                {productCreateError && (
                  <div
                    style={{
                      color: "#b00020",
                      fontSize: 12,
                      marginTop: 8,
                      width: "100%",
                    }}
                  >
                    {productCreateError}
                  </div>
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export const ModalJobService = connect(
  (state) => {
    return {
      adding: state.plugin.adding,
      showJobServiceModal: state.plugin.showJobServiceModal,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      productCreating: state.plugin.productCreating,
      productCreateError: state.plugin.productCreateError,
    };
  },
  {
    addJobService,
    setShowJobServiceModal,
    woocommerceCreateProduct,
  }
)(ModalRedux);
